/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
    Dispatch,
    SetStateAction,
    useEffect,
    useMemo,
    useState,
} from "react";
import "./FormGroupPreAceleradora.scss";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";
import FormBottomAceleradoraTwo from "../form-bottom-aceleradora-2/FormBottomAceleradoraTwo";
import FormSectionAceleradoraTwo from "../form-section-aceleradora/FormSectionAceleradoraTwo";
import { IFormPreAceleradoraSectionData } from "../../../interfaces/ReferenciaEmpleoDigital";
import warningSvg from "../../../assets/images/icons/icon-alert.svg";
import ToastAdvertiser from "../../atoms/toast-advertiser/toastAdvertiser";
import ModalDecision from "../../atoms/modal-decision/ModalDecision";
import { validateMinAge } from "../../../utils/age";
import ModalAge from "../modal-age/ModalAge";

interface IGroupFormAceleradora {
    titulosFormulario: Array<any>;
    activeIndex: number;
    setActiveIndex: Dispatch<SetStateAction<number>> | ((step: number) => void);
    activeWizard: boolean;
    endIndex: number;
    setInputValue: any;
    formValues: any;
    handleSubmitForm: any;
    inputDisabled: string[];
    fieldsToSkip?: string[];
    validBirthDate?: boolean;
    isDisabledButton?: boolean;
    handleEvent?: any;
    dateState?: any;
    talleresData?: any;
}

interface IErrorMessage {
    nombreId: string;
    errorMessage: string;
}

const FormGroupPreAceleradora = (props: IGroupFormAceleradora) => {
    const {
        titulosFormulario,
        activeIndex,
        setActiveIndex,
        activeWizard,
        endIndex,
        setInputValue,
        formValues,
        handleSubmitForm,
        inputDisabled,
        validBirthDate,
        isDisabledButton,
        fieldsToSkip,
        handleEvent,
        dateState,
        talleresData,
    } = props;

    // Estados para las validaciones basicas de los inputs.
    const [inputsErrorList, setInputErrorList] = useState<string[]>([]);
    const [customErrorMessageList, setCustomErrorMessageList] = useState<
        IErrorMessage[]
    >([]);

    const [showModalCancel, setShowModalCancel] = useState<boolean>(false);

    const [showModalInvalidAge, setShowModalInvalidAge] =
        useState<boolean>(false);

    const groupBy = (list, key) => {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };

    // Validaciones para los inputs
    const inputValidation = (type, value, nombreId) => {
        switch (type) {
            case "email":
                if (
                    !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                        value
                    ) &&
                    value
                ) {
                    setCustomErrorMessageList((prev: any) => [
                        ...prev,
                        { nombreId, errorMessage: "* El correo no es válido." },
                    ]);

                    return true;
                } else {
                    return false;
                }

            case "mobile":
                // Valida que el input contenga minimo 10 digitos
                if (value?.length != 10 && value) {
                    setCustomErrorMessageList((prev: any) => [
                        ...prev,
                        { nombreId, errorMessage: "" },
                    ]);
                    return true;
                } else {
                    return false;
                }
            default:
                return false;
        }
    };
    const createSectionList = () => {
        const sections: any = [];

        titulosFormulario[activeIndex].referenciaFormulario.map((input) => {
            if (!sections[input.seccion]) {
                sections[input.seccion] = [];
            }
            sections[input.seccion].push(input);
        });
        return sections;
    };
    const sectionList = createSectionList();

    const createlistToValidated = () => {
        const sections: any = [];

        titulosFormulario[activeIndex].referenciaFormulario.map((input) => {
            if (!sections[input.seccion]) {
                sections[input.seccion] = [];
            }
            if (fieldsToSkip?.includes(input.nombreId)) return;
            sections[input.seccion].push(input);
        });
        return sections;
    };
    const listToValidated = createlistToValidated();

    // Funcion para renderizar los campos de tipo json provenientes de contentful
    const contentfulRenderOptions = {
        renderNode: {
            [INLINES.HYPERLINK]: ({ data }, children) => (
                <a
                    style={{ color: "var(--color-magenta-white)" }}
                    href={data.uri}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                >
                    {children}
                </a>
            ),
            [BLOCKS.PARAGRAPH]: (_node, children) => {
                return <p className="small-note">{children}</p>;
            },
            [BLOCKS.EMBEDDED_ASSET]: (node, _children) => {
                return (
                    <p>
                        <img
                            src={`${node.data.target.fields.file.url}`}
                            alt={node.data.target.fields.description}
                        />
                    </p>
                );
            },
            [BLOCKS.UL_LIST]: (_node, _children) => {
                return null;
            },
        },
        renderText: (text) =>
            text.split("\n").flatMap((line, i) => [i > 0 && <br />, line]),
    };

    //Deshabilita botón de continuar hasta que se completen los campos en cada seccion
    const [disableBottom, setdisableBottom] = useState(true);

    useEffect(() => {
        listToValidated[Object.keys(listToValidated)[0]].every((section) => {
            if (!formValues[section.nombreId] && section.obligatorio) {
                setdisableBottom(true);
                return false;
            }
            setdisableBottom(false);
            return true;
        });
    }, [formValues, activeIndex]);

    // Lista los inputs requeridos
    const validateRequired = () => {
        setCustomErrorMessageList([]);
        let inputs: any = Object.entries(
            groupBy(
                titulosFormulario[activeIndex].referenciaFormulario,
                "section"
            )
        )[0][1];

        const fieldsMandatory = inputs.filter((input) => {
            return !props.fieldsToSkip?.includes(input.nombreId);
        });

        inputs = fieldsMandatory;
        // Agrega los campos no diligenciados a la lista de error
        const errorList: string[] = [];
        inputs.map((input) => {
            if (input.obligatorio && !formValues[input.nombreId]) {
                errorList.push(input.nombreId);
            }

            if (
                inputValidation(
                    input.tipoCampo,
                    formValues[input.nombreId],
                    input.nombreId
                )
            ) {
                errorList.push(input.nombreId);
            }
        });

        //Controla el scroll y lo lleva hasta el campo con error, que no este diligenciado.
        if (errorList.length > 0) {
            document.getElementById(errorList[0])?.scrollIntoView({
                behavior: "auto",
                block: "center",
                inline: "center",
            });
        }
        setInputErrorList(errorList);
        return errorList;
    };

    // REFACTOR -

    const currentSectionData = useMemo(() => {
        const section = titulosFormulario[activeIndex];

        const data = {
            section,
        } as unknown as {
            section: IFormPreAceleradoraSectionData;
        };
        return data;
    }, [activeIndex]);

    //  validate min age
    useEffect(() => {
        const birth_date = formValues?.birth_date;

        if (!birth_date) return;

        const isValidAge = validateMinAge({
            date: birth_date,
            minAge: 18,
        });

        if (!isValidAge) {
            setShowModalInvalidAge(true);
            setInputValue("birth_date" as any, "");
        }
    }, [formValues?.birth_date]);

    const handleClickNextBtn = () => {
        const currentIndex = activeIndex + 1;

        if (handleEvent != undefined) {
            handleEvent();
        }

        const errors = validateRequired();
        console.log({ errors });
        if (errors?.length === 0) {
            if (currentIndex < endIndex) {
                setActiveIndex(currentIndex);
            } else {
                handleSubmitForm();
            }
        }
    };

    const handlePrevBtn = () => {
        if (!activeIndex) return;
        setActiveIndex(activeIndex - 1);
    };

    const handleClcikCancel = () => {
        setShowModalCancel(true);
    };

    const shouldShowAlertDataProcessing = (
        (formValues?.dataProcessingAuthorization as string) || ""
    )?.startsWith("No");

    return (
        <div className="m-form-group-pre-aceleradora">
            {props.titulosFormulario[activeIndex].descripcion && (
                <div className="m-form-body-pre-aceleradora__descripcion">
                    <span>
                        {rawToReact(
                            props.titulosFormulario[activeIndex].descripcion
                                .raw,
                            contentfulRenderOptions
                        )}
                    </span>
                </div>
            )}
            {/* Crea una seccion por cada una de las secciones configuradas para los campos en contentful */}
            <div
                className={`m-form-group-pre-aceleradora__wrapper m-form-group-pre-aceleradora__wrapper-${activeIndex}`}
            >
                {currentSectionData?.section?.descripcionFija?.raw ? (
                    <div className="m-form-group-pre-aceleradora__wrapper__description">
                        {rawToReact(
                            currentSectionData?.section?.descripcionFija?.raw,
                            contentfulRenderOptions
                        )}
                    </div>
                ) : null}
                <div></div>
                <FormSectionAceleradoraTwo
                    key={`section-${currentSectionData?.section?.tituloGeneral}`}
                    titleSection={`section-${currentSectionData?.section?.tituloGeneral}`}
                    inputsSection={
                        currentSectionData?.section?.referenciaFormulario
                    }
                    setActiveIndex={setActiveIndex}
                    activeIndex={activeIndex}
                    formValues={formValues}
                    setInputValue={setInputValue}
                    inputsErrorList={inputsErrorList}
                    customErrorMessageList={customErrorMessageList}
                    inputDisabled={inputDisabled}
                    validBirthDate={validBirthDate}
                    dateState={dateState}
                    talleresData={talleresData}
                ></FormSectionAceleradoraTwo>
            </div>
            {/* Renderiza autorizacion de datos, botones de confirmacion/navegacion en la parte inferior */}
            <div className="m-form-group-pre-aceleradora__footer">
                <FormBottomAceleradoraTwo
                    activeStep={activeIndex}
                    flagGTM="ManifestacionDeInteres"
                    titleButton={titulosFormulario[activeIndex].tituloBoton}
                    disableNextBtn={
                        disableBottom ||
                        isDisabledButton ||
                        shouldShowAlertDataProcessing
                    }
                    onClickNextBtn={handleClickNextBtn}
                    onClicPrevBtn={handlePrevBtn}
                    onClickCancel={handleClcikCancel}
                />
                {shouldShowAlertDataProcessing ? (
                    <div
                        className={`m-form-group-pre-aceleradora__toast ${
                            shouldShowAlertDataProcessing
                                ? "toast-enter"
                                : "toast-exit"
                        }`}
                    >
                        <ToastAdvertiser
                            imgSrc={warningSvg}
                            text="Para continuar debes aceptar el tratamiento de datos."
                            imgBgColor="#FF0000"
                        />
                    </div>
                ) : null}
            </div>

            {showModalCancel ? (
                <ModalDecision
                    isOpen
                    title=" ¿Estás seguro que quieres cancelar el proceso de Pre-registro?"
                    confirmLink="https://www.comfama.com/trabajo-con-proposito/empleo/centro-de-empleo-para-la-industria-digital/"
                    onCancel={() => {
                        setShowModalCancel(false);
                    }}
                    onCloseModal={() => {
                        setShowModalCancel(false);
                    }}
                />
            ) : null}

            <ModalAge
                modalIsOpen={showModalInvalidAge}
                onConfirm={() => {
                    setShowModalInvalidAge(false);
                }}
                onClose={() => {
                    setShowModalInvalidAge(false);
                }}
                description={
                    <span>
                        {" "}
                        Para inscribirte en las formaciones del Centro de empleo
                        para la industria digital Comfama debes tener más de 18
                        años.
                    </span>
                }
            />
        </div>
    );
};

export default FormGroupPreAceleradora;
